import { render, staticRenderFns } from "./Operational.Integration.DuasRodas.vue?vue&type=template&id=f8a90b56&scoped=true"
import script from "./Operational.Integration.DuasRodas.vue?vue&type=script&lang=js"
export * from "./Operational.Integration.DuasRodas.vue?vue&type=script&lang=js"
import style0 from "./Operational.Integration.DuasRodas.vue?vue&type=style&index=0&id=f8a90b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a90b56",
  null
  
)

export default component.exports